<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]" custom-card-classes="chart-wrapper">
		 <v-select
        	:items="eventGroups"
		  	v-model="eventGroup"
			box
			label="Event"></v-select>
		<multi-doughnut-chart :values="values" :is-money-value="isMoneyValue" :styles="myStyles"></multi-doughnut-chart>
	</widget-card>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Enumerable from 'linq'
	import MultiDoughnutChart from './MultiDoughnutChart'
	import widgetList from '../../views/admin/dashboards/widget-list.js'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			MultiDoughnutChart
		},
		computed: {
			...mapGetters([
				'season',
				'reportingData',
				'user'
			]),
			myStyles () {
				return {
					height: `80%`,
					position: 'relative'
				}
				if (this.widget.data.groupBy === 'wo_partner_name') {
					
				} else {
					return {
						height: `95%`,
						position: 'relative'
					}
				}
			},
			eventGroups: function () {
				if (this.reportingData.length > 0 && this.season) {
					// let result = this.reportingData
					const result = Enumerable.from(this.reportingData)
						.groupBy(`{Label: $.event_group_name, FromDate: $.fromDate}`, null, (key, g) => {
							return {
								event_group_name: key.Label,
								fromDate: key.FromDate,
							}
						}, '$.Label')
						.orderBy('$.fromDate')
						.select('$.event_group_name')
						.toArray()
					this.eventGroup = result[0]
					return result
				} else {
					return []
				}
			},
			values: function () {
				if (this.reportingData.length) {
					console.log(this.widget.data.sumField)
					const enu = Enumerable.from(this.reportingData)
					// const shopColor = this.user.settings.orderHistoryShopColors.find(row => row.shopId == shopId)

					const partnerEnu = enu
						.where(item => item.event_group_name === this.eventGroup)
						.groupBy(`$.wo_partner_name`, null, (key, g) => {
							return {
								label: key || 'External',
								value: g.sum(`$.${this.widget.data.sumField.field}`),
							}
						})
						.orderBy('$.value')
						.toArray()

					const shopEnu = enu
						.where(item => item.event_group_name === this.eventGroup)
						.groupBy(`{ name: $.ShopName, color: $.color }`, null, (key, g) => {
							return {
								label: key.name,
								value: g.sum(`$.${this.widget.data.sumField.field}`),
								color: key.color
							}
						}, '$.name')
						.orderBy('$.value')
						.toArray()

					return [partnerEnu, shopEnu]
					// if (this.widget.data.sumField) {
					// 	let enu = Enumerable.from(this.reportingData)

					// 	if (this.widget.data.groupBy === 'wo_partner_name') {
					// 		enu = enu.where(item => item.event_group_name === this.eventGroup)
					// 				.groupBy(`$.${this.widget.data.groupBy}`, null, (key, g) => {
					// 					return {
					// 						label: key || 'External',
					// 						value: g.sum(`$.${this.widget.data.sumField.field}`),
					// 						color: g.select(item => item.color).first()
					// 					}
					// 				})
					// 	} else {
					// 		enu = enu.groupBy(`$.${this.widget.data.groupBy}`, null, (key, g) => {
					// 				return {
					// 					label: key,
					// 					value: g.sum(`$.${this.widget.data.sumField.field}`),
					// 					color: g.select(item => item.color).first()
					// 				}
					// 			})
					// 	}

					// 	return enu
					// 		.orderBy('$.value')
					// 		.toArray()
					// }
				} else {
					return []
				}
			},
			value: function () {
					let enumerable = Enumerable.from(this.reportingData)

					// let result = this.reportingData
					Object.keys(this.widget.data.conditions).map(key => {
						enumerable = enumerable.where(item => item[key] === this.widget.data.conditions[key])
					})
					return enumerable
						.select(item => item[this.widget.data.sumField])
						.sum()
			},
			isMoneyValue: function () {
				return this.widget.data.sumField ? this.widget.data.sumField.isMoneyValue : false
			}
		},
		data() {
			return {
				eventGroup: ''
			}
		}
	}
</script>
<style>
.chart-wrapper {
  position: relative;
  height: 95%;
  width: 100%;
}
</style>

